<div *ngIf="facade.checkInStaticContent() && !facade.showAlert()">
  <idp-check-in-widget
    (openModalEmit)="openModal($event)"
    [selectedAirport]="airportSelected"
    [content]="facade.checkInStaticContent()"
    [checkInWidgetForm]="facade.checkInForm"
    [resetErrorsTrigger]="resetErrorsTrigger"
    (analyticsEvent)="handleAnalytics($event)"
  ></idp-check-in-widget>
  <idp-airport-dropdown
    *ngIf="facade.checkInStaticContent() && isSelected"
    [openModal]="openModalEvent"
    [selectedValue]="airportSelected"
    [searchErrorMessage]="facade.airportSearchErrorService.searchErrorMessage"
    [airportModalContent]="facade.airportModalContent()"
    (airportSelected)="onAirportSelected($event)"
    (searchValueEmit)="searchForAirport($event)"
    (closeModal)="openModal(false)"
  ></idp-airport-dropdown>
</div>

<div *ngIf="facade.showAlert()" class="flex w-full flex-col items-center mt-2">
  <div
    class="text-caption-medium text-alert leading-4 h-4 flex flex-row gap-[8px]"
  >
    <svg
      width="16"
      height="16"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      class="flex-shrink-0"
    >
      <circle cx="10" cy="10" r="9.375" fill="#C01933" />
      <path d="M9.03415 15.625H10.9846V13.4507H9.03415V15.625Z" fill="white" />
      <path
        d="M9.38588 11.6428H10.6009L11.0806 4.375H8.90625C8.90625 4.375 9.44983 11.323 9.38588 11.6428Z"
        fill="white"
      />
    </svg>
    <span>{{ errorMessage }}</span>
  </div>
</div>
